export const MASTER_DATA_DEFAULT_COLUMN_NAMES = {
    VERSION: 'Version',
    START_FINANCIAL_YEAR: 'Wirtschaftsjahresbeginn',
    END_FINANCIAL_YEAR: 'Wirtschaftsjahresende',
};
